import { useQuery } from '@tanstack/react-query';
import { fetchAutomatedCampaignList } from '../../api';
import { QUERY_KEYS_ENUM } from '../../static/query-keys.enum';

export const useGetAutomatedCampaignList = (params: string) => {
  return useQuery({
    queryKey: [QUERY_KEYS_ENUM.automatedCampaignList, params],
    queryFn: () => fetchAutomatedCampaignList(params),
    enabled: !!params
  });
};
